import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import styled from "styled-components";
import {
	AppleFilled,
	FacebookFilled,
	PlayStoreFilled,
	ViberFilled,
	YoutubeFilled,
	ApkFilled,
	TelegramFilled,
} from "@assets";
import { Space } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const RootContainer = styled.div`
	min-height: calc(100vh - 118px);
	text-align: center;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;

	svg {
		cursor: pointer;
	}
`;

const SocialContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	padding: 5px;
	margin: 16px 16px 4px 16px;
`;

const SocialWrapper = styled(Space)`
	margin-top: 10px;
	gap: 24px !important;

	svg {
		width: 43px;
		height: auto;
	}
`;

const DownloadContainer = styled.div`
	background: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 92%;
	min-height: calc(100vh - 280px);
	padding: 16px;
	border-radius: 16px 16px 0px 0px;
`;

const DownloadWrapper = styled(Space).attrs({
	direction: "vertical",
})`
	gap: 15px !important;
	margin: 12px 0 0 0;
`;

export const TopWrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const TitleWrapper = styled.div`
	margin: 0px 0 5px;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 230px;
`;

export const Title = styled.p`
	color: #004F9C;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 50px;
`;

const TitleBg = ({ text }) => {
	return (
		<TopWrapper>
			<TitleWrapper>
				<Title> - {text} - </Title>
			</TitleWrapper>
		</TopWrapper>
	);
};

const AppDownload = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { social_links } = useSelector((state) => state.app.settings);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}`);
	};

	const Link = ({ url, children }) => (
		<a href={url} target="_blank" rel="noreferrer noopen">
			{children}
		</a>
	);

	return (
		<>
			<Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
			<RootContainer>
				<SocialContainer>
					<TitleBg text={t("home.appDownloadSubTitle1")} />
					<SocialWrapper>
						<Link url={social_links?.fb_link}>
							<FacebookFilled />
						</Link>
						<Link url={social_links?.viber_link}>
							<ViberFilled />
						</Link>
						<Link url={social_links?.telegram_link}>
							<TelegramFilled />
						</Link>
						<Link url={social_links?.youtube_link}>
							<YoutubeFilled />
						</Link>
					</SocialWrapper>
				</SocialContainer>

				<DownloadContainer>
					<TitleBg text={t("home.appDownloadSubTitle2")} />
					<DownloadWrapper>
						<Link url={social_links?.app_store_link}>
							<AppleFilled />
						</Link>
						<Link url={social_links?.play_store_link}>
							<PlayStoreFilled />
						</Link>
						<Link url={social_links?.download_link}>
							<ApkFilled />
						</Link>
					</DownloadWrapper>
				</DownloadContainer>
			</RootContainer>
		</>
	);
};

export default AppDownload;
